<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="propertyFeatures" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="propertyFeatureId" selectionMode="single"
  [(selection)]="propertyFeature" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="true" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <!--add new-->
      @if (propertyFeaturesList.length > 0) {
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;float: left;margin: 6px;"
        (click)="addToPropertyFeatureTemplate()">Add to Template</button>
      }
      <h1 style="float: left;margin: 6px;">Property Feature</h1>
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Property Feature +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <tr>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureVO.featureId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalVO.shortTermRentalId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'developmentVO.developmentId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}">
        <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="titleValues" appendTo="body"
          (onChange)="pt.filter($event.value, 'title', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [filter]="true" filterBy="name" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureDesc', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureVO.defaultHighlight', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureVO.featureType', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureVO.defaultFeature', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureLabel', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'quantity', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'distance', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'distanceUnit', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureVO.describesType', 'in')"></th>
      <!--<th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureVO.kbmMap', 'in')"></th>-->
      <th [ngStyle]="{'width': 'auto'}">
        <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="kbmMapValues" appendTo="body"
          (onChange)="pt.filter($event.value, 'featureVO.kbmMap', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [filter]="true" filterBy="name" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}">
        <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="vrboMapValues" appendTo="body"
          (onChange)="pt.filter($event.value, 'featureVO.vrboMap', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [filter]="true" filterBy="name" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureVO.rentalsUnitedMap', 'in')"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-propertyFeature>
    <tr>
      <td><p-checkbox (click)="addIntoCheckedList(propertyFeature)" [binary]="true"></p-checkbox> </td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(propertyFeature)"></i>
        </a>
      </span>
    </td>
    <td>{{propertyFeature.featureId}} </td>
    <td>{{propertyFeature.shortTermRentalId}}</td>
    <td>{{propertyFeature.propertyCode}}</td>
    <td>{{propertyFeature.developmentId}}</td>
    <td>{{propertyFeature.title}}</td>
    <td>{{propertyFeature.status}}</td>
    <td>@if (propertyFeature.featureDesc) {
      <span>{{propertyFeature.featureDesc.slice(0,15)}}...</span>
    }</td>
    <td>{{propertyFeature.defaultHighlight}}</td>
    <td>{{propertyFeature.featureType}}</td>
    <td>{{propertyFeature.defaultFeature}}</td>
    <td>{{propertyFeature.featureLabel}}</td>
    <td>{{propertyFeature.quantity}}</td>
    <td>{{propertyFeature.distance}}</td>
    <td>{{propertyFeature.distanceUnit}}</td>
    <td>{{propertyFeature.describesType}}</td>
    <td>{{propertyFeature.kbmMap}}</td>
    <td>{{propertyFeature.vrboMap}}</td>
    <td>{{propertyFeature.rentalsUnitedMap}}</td>
  </tr>
</ng-template>
</p-table>